import { LabsFlag } from '../enums/labsFlag'
import { useLabsMenuFlags } from './useLabsMenuFlags'

interface CustomersBalanceReportFeature {
  isCustomersBalanceEnabled: boolean
}

export const useCustomersBalanceReportFeature = (): CustomersBalanceReportFeature => {
  const labsFlags = useLabsMenuFlags()
  return { isCustomersBalanceEnabled: labsFlags[LabsFlag.ExpertReportsCustomersBalance] }
}
